<template>
    <b-modal title="Session"
             size="lg"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="83" :modifiers="['altKey']" :preventDefault="true" @success="eventType = 'start'"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="69" :modifiers="['altKey']" :preventDefault="true" @success="eventType = 'end'"></vue-keypress>
        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <div ref="inputFields">
            <b-form-row>
                <b-form-group label="Session Type"
                              class="col-md-6"
                              v-if="sessionTypeOptions">
                    <b-form-radio-group v-model="sessionType"
                                        stacked
                                        autofocus
                                        @input="sessionTypeChanged">
                        <template v-for="(sessionTypeOption, index) in sessionTypeOptions">
                            <vue-keypress key-event="keydown"
                                          :key-code="sessionTypeOption.shortcut.keyCode"
                                          :modifiers="sessionTypeOption.shortcut.modifiers"
                                          :preventDefault="true"
                                          @success="sessionType = sessionTypeOption.value"
                                          :key="'keypress' + index"
                                          v-if="sessionTypeOption.shortcut"></vue-keypress>
                            <b-form-radio :value="sessionTypeOption.value" :key="'sessiontype' + index">
                                {{ sessionTypeOption.text }}
                                <template v-if="sessionTypeOption.shortcut">
                                    ({{ sessionTypeOption.shortcut.text }})
                                </template>
                            </b-form-radio>
                        </template>
                    </b-form-radio-group>
                </b-form-group>
                <b-form-group label="Event Type"
                              label-for="eventType"
                              class="col-md-6">
                    <b-form-radio-group name="eventType"
                                        v-model="eventType"
                                        stacked>
                        <b-form-radio value="start">Start (Alt+S)</b-form-radio>
                        <b-form-radio value="end">End (Alt+E)</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-form-row>
            <b-form-row>
                <b-form-group label="Time"
                              label-for="time"
                              class="col-md-4">
                    <b-form-input ref="time"
                                  name="time"
                                  v-model="time"
                                  type="time"
                                  :disabled="!timeRequired">
                    </b-form-input>
                </b-form-group>
            </b-form-row>
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import InputMixin from '../../mixins/InputMixin';
    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeSessionDialog',
        mixins: [DateTimeMixin, InputMixin, EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: this.configuration,
                currentErrors: null,
                showErrors: false,
                sessionType: null,
                eventType: null,
                time: null,

                timeRequired: false,

                sectionsInsertedEventData: null
            }
        },
        computed: {
            sessionTypeOptions: function () {
                if (this.currentConfiguration == null) return null;
                return this.currentConfiguration.SessionTypeOptions;
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.eventType = metaData.SubType;
                            this.sessionType = metaData.SessionType;
                            this.time = (metaData.Time == null) ? null : this.formatDateTime(metaData.Time, 'HH:mm', true, true);
                            if (this.sessionType) {
                                var sessionType = this.findOptionEntry(this.currentConfiguration.SessionTypeOptions, this.sessionType);
                                this.timeRequired = sessionType.timeRequired ? true : false;
                            } else {
                                this.timeRequired = false;
                            }
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else {
                        this.sessionType = null;
                        this.eventType = null;
                        this.timeRequired = false;
                    }
                    this.sectionsInsertedEventData = null;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.sessionType = null;
                this.eventType = null;
                this.timeRequired = false;
                this.currentErrors = null;
            },
            sessionTypeChanged: function () {
                if (this.sessionType) {
                    var sessionType = this.findOptionEntry(this.currentConfiguration.SessionTypeOptions, this.sessionType);
                    this.timeRequired = sessionType.timeRequired ? true : false;
                    if (this.timeRequired) {
                        Vue.nextTick(() => {
                            Vue.nextTick(() => {
                                this.$refs.time.focus();
                            });
                        });
                    }
                } else {
                    this.timeRequired = false;
                }
            },
            insert: function () {
                this.currentErrors = []
                if (this.sessionType == null) {
                    this.currentErrors.push('An session type has to be selected');
                }
                if (this.eventType == null) {
                    this.currentErrors.push('An event type has to be selected');
                }
                var sessionType = this.findOptionEntry(this.currentConfiguration.SessionTypeOptions, this.sessionType);
                if (sessionType.timeRequired) {
                    if (sessionType.timeRequired && ((this.time == null) || (this.time == ''))) {
                        this.currentErrors.push('A time is required');
                    }
                } else
                    this.time = null;
                if (this.currentErrors.length == 0) {
                    var time = (this.time == null) ? null : this.parseDateTime(this.time, 'HH:mm', true, true);
                    var metaData = {
                        SectionId: newUuid(),
                        Type: 'session',
                        SubType: this.eventType,
                        SessionType: this.sessionType,
                        Time: time
                    }
                    var content = sessionType.text.toUpperCase();
                    content += ' ' + this.eventType.toUpperCase();
                    if (time != null) {
                        content += ' AT ' + this.formatDateTime(time, 'h:mmA', true, true);
                    }
                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var sessionSection =
                            $('<div data-type="session"/>')
                                .attr('id', metaData.SectionId)
                                .attr('data-sub-type', this.eventType)
                                .attr('data-metadata', base64EncodedMetaData)
                                .html(content)
                                .attr('data-content', content)
                                .data('content', content)
                                .insertAfter(this.currentEditorSection)[0];
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection).remove(); //remove the old section
                        }
                        this.sectionsInsertedEventData = { sections: [sessionSection] };
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
            }
        }
    }
</script>

